import type { AiCapabilityPage } from "../schema.js";
import { LIVE, ALL_ROLES } from "./_shared.js";

/**
 * `ACCT-LOGIN-LINKS` (@UC0216) — trang **redirect** (US-AIV2-0049): chat KHÔNG hỏi ô, KHÔNG có nút Đồng ý,
 * chỉ một câu giải thích + nút mở đúng màn hình `/profile` (ADR-0009 bất biến 5).
 * Cửa mobile trang này chịu trách nhiệm (QĐ PO 17/09 mục 12 — cụm tài khoản: liên kết đăng nhập; gỡ cách đăng nhập CUỐI là tự khoá mình ra ngoài ⇒ màn hình phải cảnh báo).
 */
export const ACCT_LOGIN_LINKS = {
  id: "ACCT-LOGIN-LINKS",
  uc: "@UC0216",
  tier: "redirect",
  status: LIVE,
  roles: ALL_ROLES,
  flags: [],
  slots: [],
  llm: {
    description: "Xem và quản lý các cách đăng nhập đã nối vào tài khoản của bạn (Google, Apple, Facebook, Zalo).",
    examples: [
      "liên kết đăng nhập",
      "lien ket dang nhap",
      "nối tài khoản google",
      "noi tai khoan google",
      "gỡ liên kết facebook",
      "đăng nhập bằng gì",
      // ——— 0105: thêm cho đủ 40 ———
      "go lien ket facebook",
      "dang nhap bang gi",
      "tài khoản tôi đang nối những gì",
      "tai khoan toi dang noi nhung gi",
      "nối thêm apple vào tài khoản",
      "noi them apple vao tai khoan",
      "thêm cách đăng nhập bằng zalo",
      "them cach dang nhap bang zalo",
      "tôi muốn đăng nhập bằng google luôn cho nhanh",
      "toi muon dang nhap bang google luon cho nhanh",
      "bỏ nối zalo đi",
      "bo noi zalo di",
      "xem các phương thức đăng nhập",
      "xem cac phuong thuc dang nhap",
      "tài khoản này nối với google chưa?",
      "tai khoan nay noi voi google chua",
      "nối facebook",
      "noi facebook",
      "gỡ google ra khỏi tài khoản",
      "go google ra khoi tai khoan",
      "mình hay đăng nhập bằng số nào ấy nhỉ",
      "minh hay dang nhap bang so nao ay nhi",
      "đổi cách đăng nhập",
      "doi cach dang nhap",
      "quản lý đăng nhập",
      "quan ly dang nhap",
      "liên kết apple id",
      "lien ket apple id",
      "tôi lỡ nối nhầm facebook của người khác",
      "toi lo noi nham facebook cua nguoi khac",
      "còn nối được mấy cách đăng nhập nữa",
      "con noi duoc may cach dang nhap nua",
      "cách đăng nhập nào đang bật",
      "cach dang nhap nao dang bat",
    ],
  },
  screen: "/profile",
  screenShows: "login_links",
  endpoints: [
    "GET /me/linked-accounts",
    "POST /me/linked-accounts",
    "DELETE /me/linked-accounts/{provider}",
    "GET /users/me/identity",
  ],
  facts: [],
  templates: {
    redirect: "Mình mở trang tài khoản để bạn xem các cách đăng nhập đã nối nhé.",
  },
  journey: { after: ["ACCT-PROFILE"] },
  help: { title: "Cách đăng nhập", tryNow: "liên kết đăng nhập" },
} satisfies AiCapabilityPage;
